export default "__VITE_ASSET__BMq5ul5v__"